module.exports = __webpack_public_path__ + "img/img42.17e11046.png";